/**
 * @namespace Teaserplayer
 * @aka Planet.Teaserplayer
 *
 */
Planet.Teaserplayer = (function ($, ardplayer) {

  /**
   *
   * @type Array
   */
  var _observedElements = [];

  /**
   *
   * @param entries
   * @private
   */
  var _onIntersection = function _onIntersection(entries) {
    entries.forEach(function (entry) {
      // entry.isIntersecting is null on some versions of MS Edge
      // entry.intersectionRatio can be 0 on some intersecting elements
      if (entry.isIntersecting || entry.intersectionRatio > 0) {
        _intersecting(entry.target);
      }
    })
  }

  /**
   *
   * @return {*[]}
   * @private
   */
  var _buildThresholdList = function _buildThresholdList() {
    var thresholds = [];
    var numSteps = 20

    for (var i = 1.0; i <= numSteps; i++) {
      var ratio = i / numSteps;
      thresholds.push(ratio);
    }

    thresholds.push(0);
    return thresholds;
  }

  var rootMargin = '1250px';
  try {
    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (connection) {
      switch (connection.effectiveType) {
        case 'slow-2g':
        case '2g':
        case '3g':
          rootMargin = '2500px';
          break;
        case '4g':
        default:
          rootMargin = '1250px';
          break;
      }
    }
  } catch (exception) {
    /* noop */
  }

  /**
   *
   * @type {{root: null, rootMargin: string, threshold: *[]}}
   * @private
   */
  var _intersectionObserverOptions = {
    root: null,
    rootMargin: rootMargin,
    threshold: _buildThresholdList()
  };

  /**
   *
   * @type {IntersectionObserver}
   * @private
   */
  var _intersectionObserver = new window.IntersectionObserver(_onIntersection, _intersectionObserverOptions);

  var _intersectionUnobserve = function () {
    _observedElements.forEach(function (element) {
      _intersectionObserver.unobserve(element);
    })
    _observedElements = [];
  }

  /**
   *
   * @param element
   * @private
   */
  var _intersectionUnobserveElement = function (element) {
    try {
      var _elementTeaser = element.closest(Selector.TEASER);
      if (null !== _elementTeaser) {
        _intersectionObserver.unobserve(_elementTeaser);
      }
    } catch (exception) {
      /* noop */
    }

    try {
      var i = _observedElements.indexOf(element);
      if (i > -1) {
        _observedElements.splice(i, 1);
      }
    } catch (exception) {
      /* noop */
    }
  }

  /**
   *
   * @private
   */
  var _intersectionObserve = function (_elements) {
    if (null === _elements) {
      return;
    }
    _elements.forEach(function (_element) {
      var _elementTeaser = _element.closest(Selector.TEASER);
      if (!'IntersectionObserver' in window) {
        if (null !== _elementTeaser) {
          _intersecting(_element);
        }
        return
      }
      if (null !== _elementTeaser) {
        _intersectionObserver.observe(_elementTeaser);
        _observedElements.push(_element);
      }
    })
  }

  /**
   *
   * @param {Element} elementTeaser
   * @private
   */
  var _intersecting = function _intersecting(elementTeaser) {
    var _element = elementTeaser.querySelector(Selector.DATA_SPY);
    if (null === _element) {
      return;
    }
    var $element = $(_element);
    Teaserplayer._jQueryInterface.call($element, $element.data());
  }

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'teaserplayer';
  var DATA_KEY = 'planet.' + NAME;
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Event = {
    PJAX_DATA_API: 'pjax:end' + EVENT_KEY + DATA_API_KEY,
    CLICK: 'click' + EVENT_KEY + DATA_API_KEY
  };

  var Selector = {
    DATA_SPY: '[data-spy=teaser-mediaplayer]',
    TEASER: '.teaser.teaser-mediaplayer',
    IMAGE: '.image'
  };

  var ClassName = {
    VISIBLE: 'teaser-mediaplayer-visible'
  }

  var Default = {};

  var DefaultType = {
    config: 'string'
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */
  var Teaserplayer = function () {

    function Teaserplayer(element, config) {
      var self = this;

      // protected
      self.element = element;
      self.$element = $(self.element);
      self.$elementImage = self.$element.next(Selector.IMAGE);
      self.$elementTeaser = self.$element.closest(Selector.TEASER);

      self.isVideo = self.element.classList.contains('video');

      self.config = self._getConfig(config);

      _intersectionUnobserveElement(self.element);

      // TODO: Mit Animationen umgehen
      self.hasAnimation = false;
      self.$elementTeaser.one('animationstart webkitAnimationStart oAnimationStart', function () {
        self.hasAnimation = true;
      }, false);

      self._createUx();
    }

    Teaserplayer.prototype._createUx = function _createUx() {
      var self = this;

      var $elementPlayButton = $(COMMON.Utils.template('<button class="btn-nodesign btn-{mediatype}-play btn-expendable" data-toggle="mediaplayer" aria-controls="{id}">' +
        Planet.Util.svgIcon('{mediatype}-play') +
        '<span>{label} starten</span>' +
        '</button>', {
        mediatype: self.isVideo ? 'video' : 'audio',
        label: self.isVideo ? 'Video' : 'Audio',
        id: self.$element.attr('id')
      }));

      self.$elementImage.prepend($elementPlayButton);

      $elementPlayButton.on(Event.CLICK, function () {
        self._handleClickPlay.call(self)
      });
    }

    Teaserplayer.prototype._handleClickPlay = function _handleClickPlay() {
      var self = this;

      self.$elementImage.hide();
      self.$element.show();

      // Init Videoplayer
      self.$elementVideoplayer = $(COMMON.Utils.template('<div id="player-{id}" class="{className}-player"><div data-spy="media-player"><{tagName}/></div></div>', {
        id: self.$element.attr('id'),
        className: self.isVideo ? 'video' : 'audio',
        tagName: self.isVideo ? 'video' : 'audio',
        config: self.config.config
      }));

      var $elementCloseButton = $(COMMON.Utils.template('<button class="btn-nodesign btn-close" data-dismiss="mediaplayer" aria-label="Medienplayer schließen" aria-controls="{id}">\n' +
        Planet.Util.svgIcon('close') +
        '</button>', {
        id: self.$element.attr('id')
      }));

      self.$element.append(self.$elementVideoplayer);
      self.$element.append($elementCloseButton);

      // Player initialisieren - autostart
      self.videoplayer = self.$elementVideoplayer.videoplayer({
        autostart: true,
        config: self.config.config,
        playerConfiguration: {
          web: {
            isForcedAutoPlay: false,
            isEnablePostMessage: false,
            isForcedVideoView: true,
            disableBackButtonTitle: true,
            disablePosterTitle: true
            //disablePosterImage: true
          }
        }
      });

      self.$elementTeaser.addClass(ClassName.VISIBLE);

      $elementCloseButton.on(Event.CLICK, function () {
        self._handleClickClose.call(self);
      })
    }

    Teaserplayer.prototype._handleClickClose = function _handleClickClose() {
      var self = this;

      var playerId = self.$elementVideoplayer.attr('data-uuid');
      var player = ardplayer.PlayerModel.getPlayerById(playerId);
      if ('undefined' !== typeof player) {
        player.stop();
      }

      // restore view
      self.$elementTeaser.removeClass('teaser-mediaplayer-visible');

      self.$elementImage.show();
      self.$element.hide();

      if ('undefined' !== typeof player) {
        player.dispose();
      }

      delete self.videoplayer;
      self.$element.html('');
    }

    // public
    Teaserplayer.prototype.dispose = function dispose() {
      this.element = null;
      this.config = null;
    };

    // private
    Teaserplayer.prototype._getConfig = function _getConfig(config) {
      config = $.extend({}, Default, config);

      COMMON.Utils.typeCheckConfig(NAME, config, DefaultType);

      return config;
    };

    /**
     * @static
     */
    Teaserplayer._jQueryInterface = function _jQueryInterface(config) {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);
        var _config = (typeof config === 'undefined' ? 'undefined' : COMMON.Utils._typeof(config)) === 'object' ? config : null;

        if (!data) {
          data = new Teaserplayer(this, _config);
          $(this).data(DATA_KEY, data);
        }

        if (typeof config === 'string') {
          if (data[config] === undefined) {
            throw new Error('No method named "' + config + '"');
          }
          data[config]();
        }
      });
    };

    return Teaserplayer;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */
  var elements = document.querySelectorAll(Selector.DATA_SPY);
  _intersectionUnobserve();
  _intersectionObserve(elements);
  $(document).on(Event.PJAX_DATA_API, function (event, xhr, options) {
    var container = document.querySelector(options.container);
    if (null === container) {
      return;
    }
    var elements = container.querySelectorAll(Selector.DATA_SPY);
    _intersectionUnobserve();
    _intersectionObserve(elements);
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */

  $.fn[NAME] = Teaserplayer._jQueryInterface;
  $.fn[NAME].Constructor = Teaserplayer;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Teaserplayer._jQueryInterface;
  };

  return Teaserplayer;

})(window.jQuery, window.ardplayer);

// @see https://jonsuh.com/blog/detect-the-end-of-css-animations-and-transitions-with-javascript/
